<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
</div>
<form class="form" [formGroup]="attemptForm" autocomplete="off">
  <div
    class="navi-hover scroll card-body"
    [perfectScrollbar]="{ wheelPropagation: false }"
    style="max-height: 650px"
  >
    <kt-alert *ngIf="hasFormErrors" type="warn" [showCloseButton]="false" [duration]="10000">
      {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
    </kt-alert>
    <div class="form-section form-section-first">
      <div class="form-group">
        <kt-general-autocomplete
          [label]="'Reason'"
          [loadItemsFunction]="reasonAutocompleteCall"
          [optionFormatter]="stringUtils.displayName"
          [valueFormatter]="stringUtils.displayName"
          [required]="false"
          [readOnly]="false"
          [control]="attemptForm.get('reason')"
          [change]="onReasonChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Reason'"
          #reasonAutocomplete
        ></kt-general-autocomplete>
        <kt-general-autocomplete
          [label]="'Contact'"
          [loadItemsFunction]="contactAutocompleteCall"
          [optionFormatter]="stringUtils.displayName"
          [valueFormatter]="stringUtils.displayName"
          [required]="true"
          [readOnly]="false"
          [control]="attemptForm.get('followupContact')"
          [change]="onContactChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Contact'"
          #followupContactAutocomplete
        ></kt-general-autocomplete>
        <mat-form-field class="due-date-field mat-form-field-fluid" appearance="fill">
          <mat-label>Future Date for Next Attempt</mat-label>
          <input
            required
            [owlDateTime]="dt1"
            matInput
            [placeholder]="'Follow-up Date'"
            class="clendar-btn"
            formControlName="followupDate"
          />
          <owl-date-time #dt1 [hour12Timer]="'true'"></owl-date-time>
          <mat-icon class="clickable" [owlDateTimeTrigger]="dt1" matSuffix>access_time</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Comment</mat-label>
          <textarea matInput formControlName="attempt_comment" rows="4"></textarea>
        </mat-form-field>
        <!--        <kt-comments [id]="data.transaction?data.transaction.id:data.transaction_id"  [followup_id]="data.body.id"  [comments]="comments" [type]="data.type"></kt-comments>-->
      </div>
    </div>
  </div>
</form>

<div class="card-footer">
  <div class="d-flex justify-content-between">
    <div class="mr-2"></div>
    <div>
      <button (click)="close()" type="button" mat-raised-button cdkFocusInitial matTooltip="Cancel">
        <span translate="GLOBAL.CANCEL">Cancel</span></button
      >&nbsp;
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        matTooltip="Create"
      >
        <span translate="GLOBAL.SAVE">Save</span>
      </button>
    </div>
  </div>
</div>
